import { Router, } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./login.config";
import * as i2 from "@angular/router";
var LoginGuard = /** @class */ (function () {
    function LoginGuard(loginService, auth, router) {
        this.loginService = loginService;
        this.auth = auth;
        this.router = router;
    }
    LoginGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        return this.auth.isLoggedIn().pipe(switchMap(function (loggedIn) {
            var next = route.queryParams.next;
            if (loggedIn) {
                return _this.router.navigate([next || '/']);
            }
            return _this.loginService.redirect(next || '/', route);
        }));
    };
    LoginGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginGuard_Factory() { return new LoginGuard(i0.ɵɵinject(i1.LOGIN_REDIRECT_SERVICE), i0.ɵɵinject(i1.LOGIN_AUTH_SERVICE), i0.ɵɵinject(i2.Router)); }, token: LoginGuard, providedIn: "root" });
    return LoginGuard;
}());
export { LoginGuard };
